module.exports = __webpack_public_path__ + "media/images/suppliers/candor-a16578f9d023bf9d2b7a4459e2a918eb.png";